import * as Yup from 'yup';

export const VALIDATION_SCHEMA = t =>
  Yup.object({
    phone: Yup.number(),
    is_valid_phone: Yup.bool().when('phone', {
      is: phone => !!phone,
      then: () =>
        Yup.bool()
          .oneOf([true], t('validation:phone_number_invalid'))
          .required(t('validation:phone_number_required')),
    }),
  });
